// @ts-ignore
const myAccountUrl = __MY_ACCOUNT_URL__
const GTF_BASE_URL = 'https://members.daytradeu.com';

export type PortalDestination = 'home' | 'account' | 'strategy-suite' | 'marketplace';

const ROUTE_MAP: Record<PortalDestination, { greenchart: string; gtf: string }> = {
    'home':           { greenchart: '',                         gtf: '' },
    'account':        { greenchart: 'dashboard/account',        gtf: '' },
    'strategy-suite': { greenchart: 'dashboard/strategy-suite', gtf: 'trading/strategy-suite' },
    'marketplace':    { greenchart: 'dashboard/marketplace',    gtf: '' },
};

export function getMemberPortalUrl(
    tradingHouseName: string,
    destination: PortalDestination = 'home',
    queryParams?: Record<string, string>
): string {
    const baseUrl = tradingHouseName === 'gtf' ? GTF_BASE_URL : myAccountUrl;
    const houseKey = tradingHouseName === 'gtf' ? 'gtf' : 'greenchart';
    const path = ROUTE_MAP[destination][houseKey];

    let url = path ? `${baseUrl}/${path}` : baseUrl;

    if (queryParams && Object.keys(queryParams).length > 0) {
        const qs = new URLSearchParams(queryParams).toString();
        url += `?${qs}`;
    }

    return url;
}
